<template>
  <div class="home">
    <ConsoleHeader />
    <router-view />
  </div>
</template>

<script>
// @ is an alias to /src
import ConsoleHeader from "@/components/ConsoleHeader.vue";

export default {
  name: "Console",
  components: {
    ConsoleHeader
  }
};
</script>
<style>
.home {
  margin: 0 auto;
}
</style>
